import React from 'react';
import { withRouter } from 'react-router-dom';
import FieldModal from '../../../../components/modals/fieldModal';
import API from '../../../../utils/API';

class DeleteGroupModal extends React.Component {
    state = {
        submitting: false,
        attendees: [],
        sessions: [],
        group: [],
        checkedAttendees: {},
        checkedGroups: {},
    };

    componentDidMount() {
        const { session, event } = this.props;

        let checkedAttendees = {};
        let sessionAttendees = session.selectedAttendees || []; //checkedAttendees

        for (let i = 0; i < sessionAttendees.length; i++) {
            checkedAttendees[sessionAttendees[i]._id] = true;
        }

        let checkedGroups = {};
        let sessionGroups = session.groups || []; //checkedGroups
        for (let i = 0; i < sessionGroups.length; i++) {
            checkedGroups[sessionGroups[i]._id] = true;
        }
        this.setState({
            attendees: event.attendees,
            groups: event.groups,
            checkedAttendees: checkedAttendees,
            checkedGroups: checkedGroups,
        });
    }

    submit = async () => {
        const { session, eventId, orgId, group, toggle } = this.props;
        const { checkedAttendees, checkedGroups } = this.state;

        let selectedAttendees = Object.keys(checkedAttendees);
        let selectedGroups = Object.keys(checkedGroups).filter(id => id !== group._id);
        const groupAttendees = this.state.group.filter(group => selectedGroups.includes(group._id)).flatMap(group => group.attendees);
        
        this.setState({ submitting: true });
        await API()
        .patch(`Organizations/${orgId}/events/${eventId}/sessions/${session._id}`, {
            request: 'updateAttendeesAndGroups',
            attendees: [...selectedAttendees, ...groupAttendees],
            groupIds: selectedGroups
        })
        .then((res) => {
            if (res.data) {
                let attendees = this.props.event.attendees.filter(att => res.data.attendees.includes(att._id));
                let groups = this.props.event.groups.filter(grp => selectedGroups.includes(grp._id)).map(g => {
                    return { attendees: g.attendees, name: g.name, _id: g._id }
                });
                this.props.updateAttendees(attendees);
                this.props.updateSessionGroups(groups);
                toggle();
            }
        })
        .catch((e) => {
            console.error(e);
            this.setState({ submitting: false });
        });
    };

    render() {
        const { isOpen, toggle, group } = this.props;
        const { submitting } = this.state;

        return (
            <FieldModal
                size="small"
                isOpen={isOpen}
                modalTitle={"Remove Group"}
                bodyContent={() => (
                    <div>
                        <p>
                            Are you sure you want to remove the group?
                        </p>
                    </div>
                )}
                toggle={toggle}
                actionButtonLabel={!submitting ? 'Remove' : 'Removing...'}
                actionButton={() => this.submit()} // Call submit instead of remove
                isDelete={true}
                actionButtonDisabled={submitting} // Prevent multiple clicks while submitting
            />
        );
    }
}

export default withRouter(DeleteGroupModal);
